import { RequestMethods } from '../../constants';
import { api } from '../../';
import { WorkoutEndpoints } from '~/redux/api/routes/workoutsApi/contants';
import type {
  CompleteWorkoutPayload,
  ExerciseResponse,
  WorkoutsHistoryResponse,
} from '~/redux/api/routes/workoutsApi/models';
import type { PostVoidResponse } from '~/redux/api/models';

export const workoutsAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getWorkoutsHistory: builder.query<WorkoutsHistoryResponse, void>({
      query: () => ({
        url: WorkoutEndpoints.getHistory,
        method: RequestMethods.GET,
      }),
    }),

    getExercises: builder.query<ExerciseResponse, number>({
      query: (workoutInPlanId) => ({
        url: `${WorkoutEndpoints.getExercises}${workoutInPlanId}`,
        method: RequestMethods.GET,
      }),
    }),

    completeWorkouts: builder.mutation<PostVoidResponse, CompleteWorkoutPayload[]>({
      query: (workouts) => ({
        url: `${WorkoutEndpoints.completeWorkout}`,
        method: RequestMethods.POST,
        body: { workouts },
      }),
    }),
  }),
});

export const {
  useGetWorkoutsHistoryQuery,
  useLazyGetExercisesQuery,
  useCompleteWorkoutsMutation,
} = workoutsAPI;
